import { render } from "./DocumentosComponents.vue?vue&type=template&id=46848c0e"
import script from "./DocumentosComponents.vue?vue&type=script&lang=js"
export * from "./DocumentosComponents.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__